import React from "react";

const PATHS = {
    testo_power: (
        <g>
            <path d="M32 6 55 19v26L32 58 9 45V19L32 6Z" />
            <path d="M32 44V22" />
            <path d="M23 31l9-9 9 9" />
        </g>
    ),
    nitric_flow: (
        <g>
            <circle cx="32" cy="32" r="24" />
            <path d="M12 26c6-5 10 5 16 0s10 5 16 0 6 5 8 3" />
            <path d="M12 38c6-5 10 5 16 0s10 5 16 0 6 5 8 3" />
        </g>
    ),
    calm_climax: (
        <g>
            <circle cx="32" cy="32" r="24" />
            <path d="M14 36c5-12 9 8 18 0s8 6 18-4" />
            <circle cx="32" cy="46" r="2.5" />
        </g>
    ),
};

export const ComboIcon = ({ icon = "testo_power", url = "", color = "", className = "w-8 h-8", strokeWidth = 2.4 }) => {
    if (url) return <img src={url} alt="" className={`${className} object-contain`} />;
    return (
        <svg viewBox="0 0 64 64" fill="none" stroke={color || "currentColor"} strokeWidth={strokeWidth}
            strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden>
            {PATHS[icon] || PATHS.testo_power}
        </svg>
    );
};

export default ComboIcon;
